import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inventory_report_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { project_id: number[], warehouse_id: number[] }): Promise<{ result?: { dataset?: { LicensePlateCode?: string, Location?: string, LotCode?: string, LotId?: number, LotReceiveDate?: string, MaterialCode?: string, MaterialDescription?: string, ProjectName?: string, Qty?: number, LotStatus?: string, ShipmentCode?: string, LocationStatus?: string, PackDateStart?: string, PackDateEnd?: string, Warehouse?: string, NetWeight?: number }[] } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      project_id: number[], warehouse_id: number[]    }) {
        if(isNil($inParams.project_id)) {
          return true; 
        }
        if(isNil($inParams.warehouse_id)) {
          return true; 
        }
      return false;
    }
}
